import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, PropType } from 'vue';
import { useStore, useAlert, useTranslate } from '@/composables/use-globals';
import { Member } from '@/models/member';
import moment from 'moment';
import debounce from 'lodash/debounce';


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberNote',
  props: {
  member: {
    type: Object as PropType<Member>,
    required: true,
  },
  groupId: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props

const store = useStore();
const alert = useAlert();
const translate = useTranslate();

const saving = ref(false);



const noteValue = computed(() => {
  return props.member.note?.note ?? '';
});

const label = computed(() => {
  if (props.member.note === undefined) {
    return translate('members.member_note');
  }
  const date = moment(props.member.note.updated_at).fromNow();
  return translate('members.member_note_updated_at', { updated_ago: date, updated_by: props.member.note.updated_by });
});

const savingIcon = computed(() => {
  return saving.value ? 'mdi-dots-horizontal' : 'mdi-check';
});

async function setMemberNote(value: string) {
  try {
    await store.dispatch('groupMembers/setMemberNote', {
      member: props.member,
      groupId: props.groupId,
      note: value,
    });
  } catch (e) {
    alert('error', translate('members.error_setting_note'));
  }

  saving.value = false;
}

const debouncedSetMemberNote = debounce(setMemberNote, 500);

const onChange = (value: string) => {
  saving.value = true;
  debouncedSetMemberNote(value);
};

return { __sfc: true,store, alert, translate, saving, props, noteValue, label, savingIcon, setMemberNote, debouncedSetMemberNote, onChange }
}

})